import {GetStaticProps, NextPage} from 'next';
import Layout from '@common/layout';
import React from 'react';
import {wrapper} from '@redux/index';
import {EPage, ISSRParams, TLang} from '@common/types';
import {END} from 'redux-saga';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import {getContacts} from '@redux/contacts/actions';
import {getBlog} from '@redux/blogs/actions';
import {BlogDetail} from '@modules/Blog';
import {getAppSettings, setApp} from '@redux/app/actions';
import {getStrapiQuery} from '@common/functions';
import {IBlog, IStrapiAttributes, IStrapiData} from '@redux/types';
import api from '@api/index';


const BlogDetailPage: NextPage = () => {
  const {page} = useTypedSelector(state => state.blogs)

  return (
    <Layout
      title={page?.meta?.title}
      description={page?.meta?.description}
      classNames={['wrapper-inner']}
      pipelineId={page?.meta?.pipelineId}
    >
      <BlogDetail/>
    </Layout>
  )
}

export async function getStaticPaths() {
  const query = getStrapiQuery({
    fields: ['slug'],
    populate: 'meta',
    pagination: {
      page: 1,
      pageSize: 100
    }
  })
  const res: IStrapiData<IStrapiAttributes<IBlog>[]> = await api.get('/blogs/', {query})
  const paths = res.data.filter(b => !b.attributes.meta.onlyPreview).map(i => ({
    params: {slug: i.attributes.slug}
  }))
  return {paths, fallback: false}
}

export const getStaticProps: GetStaticProps = wrapper.getStaticProps(store => async ({...etc}) => {
  const {slug} = etc.params as ISSRParams
  const locale = etc.locale as TLang
  if (locale === 'en') {
    return {
      notFound: true,
    }
  }
  store.dispatch(setApp({page: EPage.BLOG, draftMode: etc.draftMode ?? false, noEng: true}))
  store.dispatch(getAppSettings({locale}))
  store.dispatch(getContacts({locale}))
  store.dispatch(getBlog({slug: String(slug), locale}))
  store.dispatch(END)
  await store?.sagaTask.toPromise()

  return {
    props: {}
  }
})

export default BlogDetailPage
